import { asMoney } from 'lib/utilities'
import React from 'react'

export default function QuestionnaireReceipt(props) {
  const { formName, propertyAddress, unitId, subTotal, fee, total } = props

  return (
    <div className="dome-d-flex dome-flex-column dome-gap18">
      <div className="dome-d-flex dome-align-center dome-gap12">
        <i style={{ fontSize: '23px' }} className="fa-thin fa-circle-check dome-color-dark-green"></i>
        <span className="dome-h3 dome-color-dark-green">thank you for your purchase!</span>
      </div>
      <span className="dome-p1 dome-color-dark-grey">A digital receipt will also be sent to you by email.</span>
      <span className="dome-p1 dome-color-dark-grey">
        <span className="dome-text-w500">Please note:</span> A completed questionnaire will be returned to the email
        address provided once property management has completed the form(s).
      </span>
      <span className="dome-p1 dome-color-dark-grey">
        <span className="dome-text-w500">Property Address: </span>
        <span>{propertyAddress}</span>
      </span>
      <span className="dome-p1 dome-color-dark-grey">
        <span className="dome-text-w500">Unit: </span>
        <span>{unitId}</span>
      </span>
      <div className="dome-d-flex dome-flex-column dome-gap12">
        <table className="questionnaire-receipt-table">
          <tr>
            <th>document title</th>
            <th>type</th>
            <th>property</th>
            <th>price</th>
          </tr>
          <tr>
            <td>{formName}</td>
            <td>questionnaire</td>
            <td>{propertyAddress}</td>
            <td>{asMoney(subTotal)}</td>
          </tr>
        </table>
        <div style={{ paddingLeft: 12, paddingRight: 32 }}>
          <div className="dome-d-flex dome-justify-end">
            <div className="dome-d-flex dome-flex-column dome-gap12">
              <div className="dome-d-flex dome-justify-end" style={{ gap: 10 }}>
                <div className="dome-d-flex dome-flex-column text-right">
                  <span className="dome-p2 dome-color-med-grey">subtotal</span>
                  <span className="dome-p2 dome-color-med-grey">app admin fee</span>
                  <span className="dome-p2 dome-color-darkest-grey dome-text-w500">total</span>
                </div>
                <div style={{ width: 75 }} className="dome-d-flex dome-flex-column text-right">
                  <span className="dome-p2 dome-color-med-grey">{asMoney(subTotal)}</span>
                  <span className="dome-p2 dome-color-med-grey">{asMoney(fee)}</span>
                  <span className="dome-p2 dome-color-darkest-grey">{asMoney(total)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dome-d-flex dome-justify-start">
        <button type="button" onClick={() => window.print()} className="dome-btn dome-btn-base dome-btn-aqua-stroke">
          print receipt
        </button>
      </div>
    </div>
  )
}
